// extracted by mini-css-extract-plugin
export default {"list":"Product-List_list__3x9bZ","title":"Product-List_title__Cpwdi","category":"Product-List_category__rSMw+","product":"Product-List_product__NVFho"};